export default "__VITE_ASSET__7db7fc97__"